/* LYLAC premium inner-page enhancements — draft layer, safe to delete */
(function(){
  function ready(fn){document.readyState!=='loading'?fn():document.addEventListener('DOMContentLoaded',fn)}
  ready(function(){
    /* 1. Trust strip under add-to-cart on product pages */
    try{
      if(document.body.classList.contains('template-product')||/\/products\//.test(location.pathname)){
        var anchor=document.querySelector('.t4s-product-form__buttons')||document.querySelector('form[action*="/cart/add"] button[name="add"]')||document.querySelector('form[action*="/cart/add"]');
        if(anchor&&!document.querySelector('.lylac-trust')&&!document.querySelector('.lyp-trust')){
          var el=document.createElement('div');
          el.className='lylac-trust';
          el.innerHTML='<span>Nationwide Delivery</span><span>Easy Exchanges</span><span>Secure Checkout</span>';
          (anchor.closest('.t4s-product-form__buttons')||anchor).insertAdjacentElement('afterend',el);
        }
      }
    }catch(e){}

    /* 2. Sticky mobile buy bar on product pages */
    try{
      var addBtn=document.querySelector('form[action*="/cart/add"] button[name="add"], button[name="add"], .lyp-atc');
      if(addBtn&&(/\/products\//.test(location.pathname))&&!document.querySelector('.lylac-satc')){
        var ttl=(document.querySelector('.lyp-info h1, .t4s-product__info-container h1, h1')||{}).textContent||'';
        var prc=(document.querySelector('#lyp-price, .t4s-product__info-container .t4s-product-price, .t4s-product-price')||{}).textContent||'';
        var bar=document.createElement('div');
        bar.className='lylac-satc';
        bar.innerHTML='<div class="ls-i"><b></b><span></span></div><button type="button">Add to Cart</button>';
        bar.querySelector('b').textContent=ttl.trim();
        bar.querySelector('span').textContent=prc.replace(/\s+/g,' ').trim();
        bar.querySelector('button').addEventListener('click',function(){addBtn.click()});
        document.body.appendChild(bar);
        var target=addBtn.closest('form')||addBtn;
        if('IntersectionObserver' in window){
          new IntersectionObserver(function(en){
            bar.classList.toggle('on',!en[0].isIntersecting&&window.scrollY>200);
          },{threshold:0}).observe(target);
        }else{
          window.addEventListener('scroll',function(){bar.classList.toggle('on',window.scrollY>600)},{passive:true});
        }
      }
    }catch(e){}

    /* 3. Scarcity note under collection titles */
    try{
      if(document.body.classList.contains('template-collection')||/\/collections\//.test(location.pathname)){
        var h=document.querySelector('.t4s-collection-header h1, .t4s-page-title h1, #MainContent h1');
        if(h&&!document.querySelector('.lylac-col-note')){
          var n=document.createElement('p');
          n.className='lylac-col-note';
          n.textContent='Small batches. When it’s gone, it’s gone.';
          h.insertAdjacentElement('afterend',n);
        }
      }
    }catch(e){}

    /* 4. Trust reassurance under checkout button (cart page) */
    try{
      if(document.body.classList.contains('template-cart')||location.pathname==='/cart'){
        var co=document.querySelector('button[name="checkout"]');
        if(co&&!document.querySelector('.lylac-trust')){
          var tr=document.createElement('div');
          tr.className='lylac-trust lylac-trust--cart';
          tr.innerHTML='<span>Secure Checkout</span><span>Easy Exchanges</span>';
          co.insertAdjacentElement('afterend',tr);
        }
      }
    }catch(e){}

    /* 5. "Shop" in desktop header → turn into a category dropdown instead of a dead-end link */
    try{
      var cats=[
        {t:'New Arrivals',h:'new-arrivals',n:'29 styles'},
        {t:'Co-Ord Sets',h:'co-ords-sets',n:'47 styles'},
        {t:'Long Dress',h:'long-dress',n:'50 styles'},
        {t:'Shrugs',h:'shrugs',n:'19 styles'},
        {t:'Eastern',h:'eastern',n:'19 styles'},
        {t:'Most Trending',h:'most-trending',n:'13 styles'}
      ];
      var navLinks=document.querySelectorAll('header nav a, [class*="t4s-header"] nav a, .t4s-site-nav__link');
      navLinks.forEach(function(a){
        var txt=(a.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
        if(txt==='shop'){
          a.setAttribute('href','/collections');
          var li=a.closest('li');
          if(li){
            li.querySelectorAll('.t4s-sub-menu, [class*="mega"], [class*="dropdown"]').forEach(function(x){x.remove()});
            li.className=li.className.replace(/\S*has-children\S*/g,'').replace(/\S*mega\S*/g,'');
            li.classList.add('lylac-shopdrop-wrap');
            var ul=document.createElement('ul');
            ul.className='lylac-shopdrop';
            ul.innerHTML=cats.map(function(c){return '<li><a href="/collections/'+c.h+'">'+c.t+'<span>'+c.n+'</span></a></li>'}).join('');
            li.appendChild(ul);
          }
        }
      });
    }catch(e){}

    /* 6. FREE SHIPPING progress bar (threshold Rs.10,000) + prepaid bank-deposit offer */
    try{
      var FS=1000000; /* Rs.10,000 in cents */
      var css=document.createElement('style');
      css.textContent='.lylac-fsb{background:#fff;border:1px solid #e3d5ee;border-radius:16px;padding:14px 16px;margin:0 0 14px;font-family:"Jost",sans-serif}'+
      '.lylac-fsb .t{font-size:13px;font-weight:600;color:#1c1420;margin:0 0 8px}'+
      '.lylac-fsb .t b{color:#8e5bb8}'+
      '.lylac-fsb .rail{height:8px;border-radius:100px;background:#f3e8f9;overflow:hidden}'+
      '.lylac-fsb .fill{height:100%;border-radius:100px;background:linear-gradient(90deg,#b57edc,#8e5bb8);transition:width .5s cubic-bezier(.22,.8,.36,1)}'+
      '.lylac-fsb.done .t{color:#2e7d4f}.lylac-fsb.done .fill{background:linear-gradient(90deg,#4caf7d,#2e7d4f)}'+
      '.lylac-fsb .pp{font-size:11.5px;color:#5a4f61;margin:9px 0 0;line-height:1.5}'+
      '.lylac-fsb .pp:before{content:"\\2726 ";color:#8e5bb8}'+
      '#t4s-mini_cart .lylac-fsb{margin:0 0 12px}';
      document.head.appendChild(css);
      function money(c){return 'Rs.'+Number((c/100).toFixed(0)).toLocaleString('en-US')}
      function barHTML(){return '<p class="t"></p><div class="rail"><div class="fill" style="width:0%"></div></div><p class="pp">Or get FREE shipping instantly — pay Rs.2,000 advance by bank deposit and WhatsApp us your receipt after ordering.</p>'}
      function mount(){
        var spots=[];
        var co=document.querySelector('body.template-cart button[name="checkout"], form[action="/cart"] button[name="checkout"]');
        if(co&&co.closest('form'))spots.push({el:co.closest('[class*="cart-total"]')||co.parentElement,pos:'begin'});
        var mini=document.querySelector('#t4s-mini_cart .t4s-drawer__bottom');
        if(mini)spots.push({el:mini,pos:'begin'});
        spots.forEach(function(s){
          if(s.el&&!s.el.querySelector('.lylac-fsb')){
            var d=document.createElement('div');d.className='lylac-fsb';d.innerHTML=barHTML();
            s.el.insertBefore(d,s.el.firstChild);
          }
        });
      }
      function update(){
        fetch('/cart.js').then(function(r){return r.json()}).then(function(c){
          var bars=document.querySelectorAll('.lylac-fsb');
          if(!bars.length)return;
          var total=c.total_price||0;
          var pct=Math.min(100,Math.round(total*100/FS));
          var left=FS-total;
          bars.forEach(function(b){
            var t=b.querySelector('.t'),f=b.querySelector('.fill');
            if(total<=0){b.style.display='none';return}
            b.style.display='';
            f.style.width=pct+'%';
            if(left>0){b.classList.remove('done');t.innerHTML='Add <b>'+money(left)+'</b> more for <b>FREE shipping</b>'}
            else{b.classList.add('done');t.innerHTML='✦ You’ve unlocked FREE shipping!'}
          });
        }).catch(function(){});
      }
      mount();update();
      document.addEventListener('cart:refresh',function(){mount();update()});
      /* the theme rebuilds the drawer after its own AJAX cart updates — re-mount when that happens */
      var mc=document.getElementById('t4s-mini_cart');
      if(mc&&'MutationObserver' in window){
        var deb;new MutationObserver(function(){clearTimeout(deb);deb=setTimeout(function(){mount();update()},350)}).observe(mc,{childList:true,subtree:true});
      }
    }catch(e){}

    /* 7. Rename "Useful Links" footer accordion heading to "Policies" for clarity */
    try{
      var footerHeads=document.querySelectorAll('#t4s-footer [class*="heading"], #t4s-footer summary, #t4s-footer h3, #t4s-footer h4, #t4s-footer .t4s-widget-title, #t4s-footer [class*="title"]');
      footerHeads.forEach(function(h){
        var walker=document.createTreeWalker(h,NodeFilter.SHOW_TEXT,null,false);
        var node;
        while(node=walker.nextNode()){
          if(node.nodeValue.trim()==='Useful Links'){node.nodeValue=node.nodeValue.replace('Useful Links','Policies');}
        }
      });
    }catch(e){}
  });
})();
